<template>
	<div id="Amain">
    <el-scrollbar>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </el-scrollbar>
	</div>
</template>
   
<script>
export default {
  name : 'Amain',
}

</script>

<style scoped>
  #Amain{
  	height: 90%;
    margin: 40px;
    overflow-x: hidden
  }
  @media only screen and (max-width: 414px){
    #Amain{
      margin: 0;
      padding: 10px;
    }
  }
  .el-scrollbar{
    height: 90%;
  }
  .el-scrollbar__thumb{
    transform: translate(-180%,0%);
  }
  >>> .el-scrollbar__wrap{
    overflow-x: hidden
  }
  >>> .is-horizontal {
    display: none;
  }
</style>


// WEBPACK FOOTER //
// src/components/Alayout/Amain/Amain.vue